import Vue from 'vue'
import request from '@/utils/request'

const Plugin = {}

Plugin.install = function (VueConstructor) {
  VueConstructor.axios = request
  window.axios = request
  Object.defineProperties(VueConstructor.prototype, {
    axios: {
      get () {
        return request
      }
    },
    $axios: {
      get () {
        return request
      }
    }
  })
}

Vue.use(Plugin)

export { request }
export default Plugin
